<template>
  <div id="buy">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'buy',
  };
</script>



// WEBPACK FOOTER //
// Buy.vue?1639a84e